var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99999C12.3019 9.99999 14.1667 8.13523 14.1667 5.83332C14.1667 3.53142 12.3019 1.66666 10 1.66666C7.6981 1.66666 5.83333 3.53142 5.83333 5.83332C5.83333 8.13523 7.6981 9.99999 10 9.99999ZM2.5 17.5C2.5 17.9602 2.8731 18.3333 3.33333 18.3333H16.6667C17.1269 18.3333 17.5 17.9602 17.5 17.5V15.8333C17.5 13.2794 13.4742 11.6667 10 11.6667C6.52582 11.6667 2.5 13.2794 2.5 15.8333V17.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_70_2242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 16,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.99999C12.3019 9.99999 14.1667 8.13523 14.1667 5.83332C14.1667 3.53142 12.3019 1.66666 10 1.66666C7.6981 1.66666 5.83333 3.53142 5.83333 5.83332C5.83333 8.13523 7.6981 9.99999 10 9.99999ZM2.5 17.5C2.5 17.9602 2.8731 18.3333 3.33333 18.3333H16.6667C17.1269 18.3333 17.5 17.9602 17.5 17.5V15.8333C17.5 13.2794 13.4742 11.6667 10 11.6667C6.52582 11.6667 2.5 13.2794 2.5 15.8333V17.5Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_70_2242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.ceb51d963cd3d52d1b655d0f87835865.svg";
export { ForwardRef as ReactComponent };